import React, { useEffect, useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';
import { apiService } from 'services/base.service';
import PageText from 'components/base/page-text';
import { ItemDataType } from 'utils/types';
import { Breadcrumbs } from '@cokitchen/cokitchen-components';

import { ROUTE_KEYS } from 'utils/constants';
import Item from './item';
import useDashboardContext from 'contexts/dashboard.context';

const CategoryItems = () => {
  const { category_id } = useParams();
  const { routePrefix } = useDashboardContext();
  const [loading, setLoading] = useState(false);
  const [itemList, setItemList] = useState<ItemDataType[]>([]);

  const shopId = useMemo(() => itemList[0]?.shop_id, [itemList]);
  const selectedCategory = useMemo(() => itemList[0]?.category, [itemList]);
  const query = itemList.length > 0 ? `?shop=${shopId}` : '';
  const breadCrumbs = [
    {
      name: `View Shop`,
      path: `${routePrefix}/${ROUTE_KEYS.ITEMS_BY_CATEGORY}${query}`
    },
    {
      name: itemList.length > 0 ? selectedCategory?.name : '...',
      path: ''
    }
  ];
  const fetchData = async () => {
    if (!category_id) return;
    try {
      setLoading(true);
      const response = await apiService.get(`shops/categories/${category_id}/products`);
      const items = response.data.data;

      setItemList(items);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <div>
      <div className='flex flex-wrap items-start justify-between mb-6'>
        {<Breadcrumbs breadcrumbs={breadCrumbs} />}
      </div>
      {loading ? (
        <PageText text='loading' />
      ) : itemList.length === 0 ? (
        <PageText text='No items found' />
      ) : (
        <div className='grid md:grid-cols-3 lg:grid-cols-4 gap-6'>
          {itemList.map((item) => {
            return <Item key={item.id} item={item} />;
          })}
        </div>
      )}
    </div>
  );
};

export default CategoryItems;
